import NetcompanyMobile from "./NetcompanyMobile";
import TeknikMobile from "./TeknikMobile";
import OptimizerMobile from "./OptimizerMobile";

function ExperienceMobile() {
  return (
    <section id="experience" className="pt-[80px]">
      <div className="flex flex-row items-center">
        <p className="text-xl font-bold mb-8">EXPERIENCE</p>
      </div>
      {/* <TAMobile /> */}
      <NetcompanyMobile />
      <OptimizerMobile />
      <TeknikMobile />
    </section>
  );
}

export default ExperienceMobile;
